module.exports = __webpack_public_path__ + "img/1 (34).0f112349.png";